import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../../locales/en/translation.json";
import translationFI from "../../locales/fi/translation.json";
import translationSV from "../../locales/sv/translation.json";
import translationNO from "../../locales/no/translation.json";
import LanguageDetector from "i18next-browser-languagedetector";
const resources = {
  en: { translation: translationEN },
  fi: { translation: translationFI },
  sv: { translation: translationSV },
  no: { translation: translationNO },
};

const options = {
  order: ["querystring", "localStorage"],
  caches: ["localStorage"],
};

i18n.use(initReactI18next).use(LanguageDetector).init({
  resources,
  fallbackLng: "sv",
  debug: false,
  keySeparator: false,
  detection: options,
});
//Not using Suspense you will need to handle the not ready state yourself by eg. render a loading component as long ready === false.
//Not doing so will result in rendering your translations before
//they loaded which will cause save missing be called although translations exists (just yet not loaded).
// https://react.i18next.com/latest/trans-component för string interpolation

export default i18n;
